import { memo } from "react";
import { Navigate, Route } from "react-router-dom";

import Login from "../pages/loginpages/signin";
import Forgot from "../pages/loginpages/forgot";
import Password from "../pages/loginpages/password";

import DashboardOverview from "../pages/dashboardOverview";
import Orders from "../pages/orders";
import OrdersView from "../pages/OrdersView";
import OrderDrivers from "../pages/OrderDrivers";
import ManagementDriver from "../pages/loginpages/Managementpages/ManagementDriver";
import ManagementDriverView from "../pages/loginpages/Managementpages/ManagementDriverView";
import Sales from "../pages/sales";
import Vendors from "../pages/vendors";
import Drivers from "../pages/Drivers";
import Profiledetail from "../pages/profiledetail";
import Protected from "./Protected";
import ManagementUserView from "../pages/loginpages/Managementpages/ManagementUserView";
import ManagementVendors from "../pages/loginpages/Managementpages/ManagementVendors";
import ManagementVendorsView from "../pages/loginpages/Managementpages/ManagementVendorsView";
import ManagementUsers from "../pages/loginpages/Managementpages/ManagementUsers";
import DashboardOverviewNew from "../pages/DashboardOverviewNew";
import AddDriver from "../pages/adddriver";
import Category from "../pages/loginpages/Managementpages/category";
import Categorylist from "../pages/loginpages/Managementpages/categorylist";
import SubCategorylist from "../pages/loginpages/Managementpages/Subcategorylist";
import Subcategory from "../pages/loginpages/Managementpages/SubCategory";

import CouponsList from "../pages/loginpages/Coupons/CouponsList.js";
import Coupons from "../pages/loginpages/Coupons/Coupons";
import Faq from "../pages/loginpages/Managementpages/Addfaq";
import FaqList from "../pages/loginpages/Managementpages/faqlist";
import Cms from "../pages/loginpages/Managementpages/Addcms";
import CmsList from "../pages/loginpages/Managementpages/cmslist";
import FinanceDrivers from "../pages/FinancePages/FinanceDrivers";
import FinanceReports from "../pages/FinancePages/FinanceReports";
import FinanceVendorsView from "../pages/FinancePages/FinanceVendorsView";
import FinanceSales from "../pages/FinancePages/FinanceSales";
import FaqEditPage from "../pages/loginpages/Managementpages/FaqEditPage";
import CmslistEdit from "../pages/loginpages/Managementpages/CmslistEdit";
import AdminDiagnosis from "../pages/loginpages/AdminDiagnosis";
// import FinanceVendor from "../pages/FinancePages/FinanceVendors";
import Add from "../pages/socialLinks/add";
import Lists from "../pages/socialLinks/lists";
import EmailTemplateView from "../pages/Emailtemplate/emailtemplateview";
import EmailTemplateList from "../pages/Emailtemplate/emailtemplatelist";
//subscribe
import Subscribeadd from "../pages/Subscribe/subscribeadd";
import Subscribelists from "../pages/Subscribe/subscribelists";

import Cmsadd from "../pages/cms_modules/cmsadd";
import Listcms from "../pages/cms_modules/listcms";

import FaqVig from "../pages/loginpages/Managementpages/FAQ/Addfaq";
import FaqListVig from "../pages/loginpages/Managementpages/FAQ/faqlist";
import DeliveryTimeCharge from "../pages/DeliveryTimeCharge";
import MenuManager from "../pages/loginpages/Managementpages/MenuManager";

// Location

import Locations from "../pages/Location/Locations";
import DeliveryZone from "../pages/Location/DeliveryZone";
import UserAccessView from "../pages/settings/UserAccessView";
import Notification from "../pages/Notification.js";
import VendorFinance from "../pages/FinancePages/VendorFinance.js";
import DriverFinance from "../pages/FinancePages/DriverFinance.js";
import ReportFinance from "../pages/FinancePages/ReportFinance.js";
import SalesFinance from "../pages/FinancePages/SalesFinance.js";
import UserAccess from "../pages/settings/UserAccess.js";
import AddUser from "../pages/settings/AddUser.js";
import LocationAction from "../pages/Location/AddLocation.js";
import Settings from "../pages/Settings/Settings.js";

import ContactUsList from "../pages/ContactUs/ContactusList.js";
import ContactUsDetail from "../pages/ContactUs/CotactusDetail.js";
import SupportTicketList from "../pages/SupportTicket/SupportTicketList.js";
import SupportTicketDetail from "../pages/SupportTicket/SupportTicketDetail.js";
import AdminList from "../pages/admin/adminlist.js";
import AdminView from "../pages/admin/adminview.js";
import City from "../pages/city/city.js";
import CityContents from "../pages/city/CityContents.js";
import CityFaq from "../pages/city/CityFaq.js";


import CategoryContents from "../pages/loginpages/Managementpages/CategoryContents.js";
import CategorySeo from "../pages/loginpages/Managementpages/CategorySeo.js";
import SubCategorySeo from "../pages/loginpages/Managementpages/SubCategorySeo.js";
import CategoryFaq from "../pages/loginpages/Managementpages/CategoryFaq.js";


import SubCategoryContents from "../pages/loginpages/Managementpages/SubCategoryContents copy.js";
import SubCategoryFaq from "../pages/loginpages/Managementpages/SubCategoryFaq.js";
import Sitemap from "../pages/sitemap.js";
import Layout from "../layouts/Layout.js";
import Otpverfication from "../pages/loginpages/otpverfication.js";
import NotFound from "../pages/NotFound.js";
const FinanceVendor = require("../pages/FinancePages/FinanceVendors").default;

export const LoginRoutes = (Auth) => {
  console.log("jkdhjkfsdf", Auth);
  // Auth = true
  return (
    <>
      {/* <Route
        path="/dashboard"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <DashboardOverview />
          </Protected>
        }
      />
       <Route
        path="/city"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <City />
          </Protected>
        }
      />
      <Route
        path="/city-contents/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityContents />
          </Protected>
        }
      />

<Route
        path="/add-city-contents/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityContents />
          </Protected>
        }
      />

<Route
        path="/edit-city-contents/:id/:_id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityContents />
          </Protected>
        }
      />

<Route
        path="/city-faq/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityFaq />
          </Protected>
        }
      />

<Route
        path="/add-city-faq/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityFaq />
          </Protected>
        }
      />

<Route
        path="/edit-city-faq/:id/:_id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityFaq />
          </Protected>
        }
      />

  <Route
        path="/city-contents/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityContents />
          </Protected>
        }
      />

<Route
        path="/add-city-contents/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityContents />
          </Protected>
        }
      />

<Route
        path="/edit-city-contents/:id/:_id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityContents />
          </Protected>
        }
      />

<Route
        path="/city-faq/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityFaq />
          </Protected>
        }
      />

<Route
        path="/add-city-faq/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityFaq />
          </Protected>
        }
      />

<Route
        path="/edit-city-faq/:id/:_id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CityFaq />
          </Protected>
        }
      />







<Route
        path="/category-seo/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CategorySeo />
          </Protected>
        }
      />

<Route
        path="/subcategory-seo/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <SubCategorySeo/>
          </Protected>
        }
      />

<Route
        path="/category-contents/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CategoryContents />
          </Protected>
        }
      />

<Route
        path="/add-category-contents/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CategoryContents />
          </Protected>
        }
      />

<Route
        path="/edit-category-contents/:id/:_id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CategoryContents />
          </Protected>
        }
      />

<Route
        path="/category-faq/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CategoryFaq />
          </Protected>
        }
      />

<Route
        path="/add-category-faq/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CategoryFaq />
          </Protected>
        }
      />

<Route
        path="/edit-category-faq/:id/:_id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <CategoryFaq />
          </Protected>
        }
      />








<Route
        path="/subcategory-contents/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <SubCategoryContents />
          </Protected>
        }
      />

<Route
        path="/add-subcategory-contents/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <SubCategoryContents />
          </Protected>
        }
      />

<Route
        path="/edit-subcategory-contents/:id/:_id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <SubCategoryContents />
          </Protected>
        }
      />

<Route
        path="/subcategory-faq/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <SubCategoryFaq />
          </Protected>
        }
      />

<Route
        path="/add-subcategory-faq/:id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <SubCategoryFaq />
          </Protected>
        }
      />

<Route
        path="/edit-subcategory-faq/:id/:_id"
        element={
          <Protected isSignedIn={Auth}>
            {" "}
            <SubCategoryFaq />
          </Protected>
        }
      />


<Route
        path="/sitemap"
        element={
          <Protected isSignedIn={Auth}>
            <Sitemap />
         </Protected>
        }
      />
     <Route
        path="/sitemap-add"
        element={
          <Protected isSignedIn={Auth}>
            <Sitemap />
         </Protected>
        }
      />
       <Route
        path="/sitemap-edit/:_id"
        element={
          <Protected isSignedIn={Auth}>
            <Sitemap />
         </Protected>
        }
      />
     <Route
        path="/sitemap-all/:from/:sitemapName"
        element={
          <Protected isSignedIn={Auth}>
            < Sitemap/>
         </Protected>
        }
      />
        <Route
        path="/sitemap-all-edit/:from/:id"
        element={
          <Protected isSignedIn={Auth}>
            <Sitemap />
         </Protected>
        }
      />
        <Route
        path="/sitemap-all-add/:from/:sitemapName"
        element={
          <Protected isSignedIn={Auth}>
            <Sitemap />
         </Protected>
        }
      /> */}


      <Route path="/" element={<Layout isSignedIn={Auth} />} >

        <Route path="/dashboard" element={<DashboardOverview />} />
        <Route path="/city" element={<City />} />
        <Route path="/city-contents/:id" element={<CityContents />} />
        <Route path="/add-city-contents/:id" element={<CityContents />} />
        <Route path="/edit-city-contents/:id/:_id" element={<CityContents />} />
        <Route path="/city-faq/:id" element={<CityFaq />} />
        <Route path="/add-city-faq/:id" element={<CityFaq />} />
        <Route path="/edit-city-faq/:id/:_id" element={<CityFaq />} />
        <Route path="/city-contents/:id" element={<CityContents />} />
        <Route path="/add-city-contents/:id" element={<CityContents />} />
        <Route path="/edit-city-contents/:id/:_id" element={<CityContents />} />
        <Route path="/city-faq/:id" element={<CityFaq />} />
        <Route path="/add-city-faq/:id" element={<CityFaq />} />
        <Route path="/edit-city-faq/:id/:_id" element={<CityFaq />} />
        <Route path="/category-seo/:id" element={<CategorySeo />} />
        <Route path="/subcategory-seo/:id" element={<SubCategorySeo />} />
        <Route path="/category-contents/:id" element={<CategoryContents />} />
        <Route path="/add-category-contents/:id" element={<CategoryContents />} />
        <Route path="/edit-category-contents/:id/:_id" element={<CategoryContents />} />
        <Route path="/category-faq/:id" element={<CategoryFaq />} />
        <Route path="/add-category-faq/:id" element={<CategoryFaq />} />
        <Route path="/edit-category-faq/:id/:_id" element={<CategoryFaq />} />
        <Route path="/subcategory-contents/:id" element={<SubCategoryContents />} />
        <Route path="/add-subcategory-contents/:id" element={<SubCategoryContents />} />
        <Route path="/edit-subcategory-contents/:id/:_id" element={<SubCategoryContents />} />
        <Route path="/subcategory-faq/:id" element={<SubCategoryFaq />} />
        <Route path="/add-subcategory-faq/:id" element={<SubCategoryFaq />} />
        <Route path="/edit-subcategory-faq/:id/:_id" element={<SubCategoryFaq />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/sitemap-add" element={<Sitemap />} />
        <Route path="/sitemap/:from/add" element={< Sitemap />} />
        <Route path="/sitemap/:from/edit/:id" element={<Sitemap />} />
        <Route path="/add-city" element={<City />} />
        <Route path="/edit-city/:id" element={<City />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/ordersview" element={<OrdersView />} />
        <Route path="/ordersdriver" element={<OrderDrivers />} />
        <Route path="/managementdriver" element={<ManagementDriver />} />
        <Route path="/managementdriverview" element={<ManagementDriverView />} />
        <Route path="/managementusers" element={<ManagementUsers />} />
        <Route path="/managementusersview" element={<ManagementUserView />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/locationview" element={<LocationAction />} />
        <Route path="/deliveryzone" element={<DeliveryZone />} />
        <Route path="/financevendor" element={<VendorFinance />} />
        <Route path="/financedrivers" element={<DriverFinance />} />
        <Route path="/financereports" element={<ReportFinance />} />
        <Route path="/financesales" element={<SalesFinance />} />
        <Route path="/faqeditpage" element={<FaqEditPage />} />
        <Route path="/cmseditpage" element={<CmslistEdit />} />
        <Route path="/diagnosis" element={<AdminDiagnosis />} />
        <Route path="/deliverytimecharge" element={<DeliveryTimeCharge />} />
        <Route path="/financevendorview" element={<FinanceVendorsView />} />
        <Route path="/managementvendors" element={<ManagementVendors />} />
        <Route path="/managementvendorsview" element={<ManagementVendorsView />} />
        <Route path="/managementvendorsview/:Id" element={<ManagementVendorsView />} />
        <Route path="/addseller" element={<ManagementVendorsView />} />
        <Route path="/sales" element={<Sales />} />
        <Route path="/vendor" element={<Vendors />} />
        <Route path="/drivers" element={<Drivers />} />
        <Route path="/profiledetail" element={<Profiledetail />} />
        <Route path="/newbb" element={<DashboardOverviewNew />} />
        <Route path="/adddriver" element={<AddDriver />} />
        <Route path="/Category" element={<Category />} />
        <Route path="/Category/:Id" element={<Category />} />
        <Route path="/Categorylist" element={<Categorylist />} />
        <Route path="/subcategory" element={<Subcategory />} />
        <Route path="/subcategory/:Id" element={<Subcategory />} />
        <Route path="/subcategorylist" element={<SubCategorylist />} />
        <Route path="/couponslist" element={<CouponsList />} />
        <Route path="/coupons" element={<Coupons />} />
        <Route path="/Faq/" element={<Faq />} />
        <Route path="/useraccess" element={<UserAccess />} />
        <Route path="/useraccessview" element={<UserAccessView />} />
        <Route path="/adduser" element={<AddUser />} />
        <Route path="/Cms/" element={<Cms />} />
        <Route path="/Cms/:Id" element={<Cms />} />
        <Route path="/FaqList" element={<FaqList />} />
        <Route path="/CmsList" element={<CmsList />} />
        <Route path="/Faq" element={<Faq />} />
        <Route path="/Faqdetail" element={<Faq />} />
        <Route path="/add" element={<Add />} />
        <Route path="/lists" element={<Lists />} />
        <Route path="/templateview" element={<EmailTemplateView />} />
        <Route path="/templatelist" element={<EmailTemplateList />} />
        <Route path="/subscribeadd" element={<Subscribeadd />} />
        <Route path="/subscribelists" element={<Subscribelists />} />
        <Route path="/cmsadd" element={<Cmsadd />} />
        <Route path="/listcms" element={<Listcms />} />
        <Route path="/menumanager" element={<MenuManager />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/settings" element={< Settings />} />
        <Route path="/contactuslist" element={<ContactUsList />} />
        <Route path="/contactdetail" element={<ContactUsDetail />} />
        <Route path="/supportticketlist" element={<SupportTicketList />} />
        <Route path="/supportticketdetail" element={<SupportTicketDetail />} />
        <Route path="/adminlist" element={< AdminList />} />
        <Route path="/addadmin" element={< AdminView />} />
        <Route path="/adminview" element={< AdminView />} />
        
        <Route path="/sitemap-all-add/:from/:sitemapName" element={< Sitemap />} />
        <Route path="/sitemap-all-edit/:from/:id" element={< Sitemap />} />
        <Route path="/sitemap-all/:from/:sitemapName" element={< Sitemap />} />
        <Route path="/sitemap-edit/:_id" element={< Sitemap />} />

      </Route >

    </>
  );
};
